// Localized display helpers for canonical (DB-stored, English) titles and
// suite codes. The DB keeps the canonical value; the UI localizes at render.
export const SUITE_NAMES = {
  talentcheck: 'TalentCheck',
  talentmap: 'TalentMap',
  talentstart: 'TalentStart',
  talentfix: 'TalentFix',
  talenttrain: 'TalentTrain',
  talentcompetency: 'TalentCompetency',
  climara: 'CLIMARA',
  talentexit: 'TalentExit',
  talentperformance: 'TalentPerformance',
  succession: 'Succession',
  talentheart: 'TalentHeart',
  intelligence: 'TalentIntelligence',
  workforce_records: 'Workforce Records',
};

const CANONICAL_TITLES_ES = {
  'TalentCheck — Psychological Candidate & Staff Evaluation':
    'TalentCheck — Evaluación psicológica de candidatos y personal',
  'TalentMap — Career & Potential Mapping':
    'TalentMap — Mapeo de carrera y potencial',
  'TalentFix — Organizational Case Intervention':
    'TalentFix — Intervención de casos organizacionales',
  'TalentTrain — Training & Development':
    'TalentTrain — Formación y desarrollo',
};

export function suiteDisplayName(code) {
  return SUITE_NAMES[(code || '').toLowerCase()] || code || '—';
}

export function localizeAssignmentTitle(title, lang) {
  if (!title) return title;
  const isES = (lang || '').toLowerCase().startsWith('es');
  return isES ? (CANONICAL_TITLES_ES[title] || title) : title;
}
